import * as React from 'react'
import { Button } from 'primereact/button'
import Icon from 'app/shared/components/Icon'
import { default as Navigation } from 'app/pages/etc/mnu/ETCMNU0101'

// interface props {
//     open: Boolean
//     onClose?: () => void
// }

// const Navigation: React.FC<props> = ({ open = false, onClose }) => {
//     const [naviHandle, setNaviHandle] = React.useState(open)
//     React.useEffect(() => {
//         setNaviHandle(open)
//     }, [open])
//     return (
//         <aside id="navigation" className={open === true ? 'open' : null}>
//             <Button onClick={onClose}>
//                 <Icon name="x2" text="전체메뉴"></Icon>
//             </Button>
//             <ETCMNU0101 />
//         </aside>
//     )
// }

export default Navigation
